export const migrateAlertsOrganizationCountBulkActionType = 'migrateAlertsOrganizationCount';
